import { fromEvent } from 'rxjs';
import VMasker from 'vanilla-masker';
import splitOnLastSpace from 'utils/splitOnLastSpace';
import postRegistrationData from 'api/postSaveContact';

/* DOM Elements */
const submitButton = document.querySelector('[data-registration-form-submit]');
const emailInput = document.querySelector('[data-registration-form-email]');
const phoneInput = document.querySelector('[data-registration-form-phone]');
const termsCheckbox = document.querySelector('[data-registration-form-terms]');
const nameInput = document.querySelector('[data-registration-form-name]');
const form = document.querySelector('[data-registration-form]');
const errorNotificationWrapper = document.querySelector(
  '[data-registration-form-notification]'
);

const successModalDialog = document.querySelector('[data-confirmation-dialog]');
const successModalCloseButtons = successModalDialog.querySelectorAll('[data-confirmation-dialog-close]');

/**
 * Handles the form submission by gathering input data,
 * sending it to the backend, and displaying success or error messages.
 */
const submitButtonHandler = async () => {
  const fullName = nameInput ? nameInput.value : '';
  // we assume the name follows the English convention of "First Middle Last"
  // so we split on the last space to get first and last names
  const [firstName, lastName] = splitOnLastSpace(fullName);
  const data = {
    email: emailInput ? emailInput.value : '',
    phone: phoneInput ? phoneInput.value : '',
    termsAccepted: termsCheckbox ? termsCheckbox.checked : false,
    firstName,
    lastName,
  };

  // hide previous notification and clear message
  errorNotificationWrapper.hidden = true; // Hide notification initially
  errorNotificationWrapper.textContent = ''; // Clear previous messages

  try {
    const response = await postRegistrationData(data);

    if (response) {
      const message = 'Thank you for signing up!';
      form.reset(); // Reset the form on success
      submitButton.disabled = true; // Disable the submit button to prevent empty submissions
      successModalDialog.showModal();

      const customEvent = new CustomEvent('successful_registration', {
        detail: message
      });

      form.dispatchEvent(customEvent);
    }
  } catch (error) {
    errorNotificationWrapper.textContent = 'There was an error processing your registration. Please try again later.';
    errorNotificationWrapper.hidden = false;
    const customEvent = new CustomEvent('failed_registration', {
      detail: error.message
    });
    form.dispatchEvent(customEvent);
  }
};


/**
 * Prevents the default form submission behavior.
 * @param {Event} event - The form submit event object.
 */
const submitFormHandler = (event) => {
  event.preventDefault();
};

/**
 * Closes the confirmation modal dialog.
 */
const closeSuccessModalDialog = () => {
  successModalDialog.close();
};

/**
 * Sets up event listeners for form interaction events.
 * This includes input, focus, and select events for the email, phone, and name inputs,
 * as well as change and focus events for the terms checkbox.
 */
export default function setupFormInteractionEvents() {
  // setup phone input masking
  if (phoneInput) {
    VMasker(phoneInput).maskPattern('(999) 999-9999');
  }

  fromEvent(form, "submit").subscribe(submitFormHandler);

  if (submitButton) {
    fromEvent(submitButton, 'click').subscribe(submitButtonHandler);
  }

  successModalCloseButtons.forEach((closeButton) => {
    fromEvent(closeButton, 'click').subscribe(closeSuccessModalDialog);
  });
}

